import { Activity } from "lucide-react";
import { useTranslation } from "react-i18next";
import PpDashboardView from "../components/PpDashboardView";

export default function TableauPP() {
  const { t } = useTranslation();
  return (
    <div className="p-4 sm:p-6 min-h-screen bg-[#0a1721] text-slate-100" data-testid="pp-tableau-page">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6">
          <div className="flex items-center gap-2 text-teal-400"><Activity className="h-5 w-5" /><span className="text-xs font-semibold uppercase tracking-widest">{t("vieSociale.brand")}</span></div>
          <h1 className="text-3xl sm:text-4xl font-extrabold mt-1">{t("pp.dashTitle")}</h1>
          <p className="text-slate-400 text-sm mt-1">{t("pp.subtitle")}</p>
        </div>
        <PpDashboardView />
      </div>
    </div>
  );
}
